import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import * as logger from '../../../logger';
import {
    Grid,
    IconButton,
    Button,
    Card,
    CardContent,
    List,
    ListItem
} from '@material-ui/core';
import { getSinglePartyPaymentDetails } from '../../../store/actions/partiesActionCreator';
import { updateChatView } from "../../../store/actions/userActionCreators";
import { TransactionDetailsSideBarCss } from "./InvoiceSideBarCss";
import DeleteIcon from '@material-ui/icons/Delete';
import { numberFormat, getVehicleNumberValuesDWeb } from '../../../utils/utils';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import DeleteTransactionDialog from './DeleteTransactionDialog';

const TransactionDetailsSideBar = ({
    open,
    onClose,
    onDelete,
    transactionId,
    customerId,
    dispatchChatView,
    dispatchGetSinglePartyPayment
}) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [paymentDetails, setPaymentDetails] = useState({});
    const [deletePayment, setDeletePayment] = useState(false);

    const classes = TransactionDetailsSideBarCss();

    useEffect(() => {

        dispatchChatView(false);

        dispatchGetSinglePartyPayment(customerId, transactionId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Transaction Details Side Bar Dweb', 'Get Single Party Payment Successfull');
                    if (data.response) {
                        setPaymentDetails(data.response);
                    }
                }
            },
            () => {
                logger.log('Transaction Details Side Bar Dweb', 'Get Single Party Payment Failed');
            }
        )

    }, [open]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const handleDeletePayment = () => {
        setDeletePayment(true);
    }

    const handleDeletePaymentClose = () => {
        setDeletePayment(false);
    }

    const handleDeletePaymentConfirm = () => {
        setDeletePayment(false);
        onDelete();
        dispatchChatView(true);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-trannsaction-details-side-bar"} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divAlign}>
                        <div className={classes.divTitle}>
                            Transaction Details
                        </div>
                        {/* <IconButton className={classes.deleteButton} onClick={() => handleDeletePayment()}>
                            <DeleteIcon className={classes.deleteIcon} />
                        </IconButton> */}
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Card className={classes.cardV1}>
                        <CardContent className={classes.cardContent} >

                            {/* ********************************* 1st Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Party Name</div>
                                    <div className={classes.textV1}>{paymentDetails && paymentDetails.customerName ? paymentDetails.customerName : ""}</div>
                                </Grid>
                                <Grid item>
                                    <div className={classes.titleV2}>Received Amount</div>
                                    <div className={classes.textV6}>{numberFormat(paymentDetails && paymentDetails.amount ? paymentDetails.amount : 0)}</div>
                                </Grid>
                            </Grid>

                            {/* ********************************* 2nd Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap" className={classes.mtV1}>
                                <Grid item>
                                    <div className={classes.titleV1}>Payment Date</div>
                                    <div className={classes.textV1}>{paymentDetails && paymentDetails.paymentDate ? paymentDetails.paymentDate : "--"}</div>
                                </Grid>
                                <Grid item>
                                    <div className={classes.titleV2}>Payment method</div>
                                    <div className={classes.textV2}>{paymentDetails && paymentDetails.paymentMode ? paymentDetails.paymentMode : "--"}</div>
                                </Grid>
                            </Grid>

                            {/* ********************************* 3rd Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap" className={classes.mtV1}>
                                <Grid item>
                                    <div className={classes.titleV1}>Reference Number</div>
                                    <div className={classes.textV1}>{paymentDetails && paymentDetails.paymentData ? paymentDetails.paymentData : "--"}</div>
                                </Grid>
                            </Grid>

                            {/* ********************************* 4th Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap" className={classes.mtV1}>
                                <Grid item>
                                    <div className={classes.titleV1}>Notes</div>
                                    <div className={classes.textV7}>{paymentDetails && paymentDetails.description ? paymentDetails.description : "--"}</div>
                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>


                    {/* ************************************** Trip Details Cards ************************************* */}
                    {(paymentDetails && paymentDetails.attributedTrips && paymentDetails.attributedTrips.length > 0) &&
                        <>
                            <hr className={classes.hrV1} />

                            <div className={classes.divTripDetails} >
                                <div className={classes.divAlignV2}>
                                    <div className={classes.tripDetailsText}>TRIP DETAILS</div>
                                    <div className={classes.tripDetailsText}>AMOUNT LINKED</div>
                                </div>

                                <List className={classes.listV1}>
                                    {paymentDetails && paymentDetails.attributedTrips && paymentDetails.attributedTrips.map((tripDetails, index) => (
                                        <ListItem className={index == 0 ? classes.cardV2 : classes.cardV3}>

                                            <Grid container justify="space-between">
                                                <Grid item className={classes.gridV1}>
                                                    <span className={classes.textV3}>{tripDetails && tripDetails.startLocation ? tripDetails.startLocation : ""}</span>
                                                    &nbsp;to&nbsp;
                                                    <span className={classes.textV3}>{tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : ""}</span>
                                                </Grid>
                                                <Grid item className={classes.amountV1} >
                                                    {numberFormat(tripDetails && tripDetails.attributedAmount ? tripDetails.attributedAmount : 0)}
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.mtV2} alignItems="center">
                                                <Grid item className={classes.textV4}>
                                                    {tripDetails && tripDetails.tripStartDate ? tripDetails.tripStartDate : ""}
                                                </Grid>
                                                {tripDetails && tripDetails.vehicleNumber &&
                                                    <>
                                                        <FiberManualRecordIcon className={classes.dotV1} />
                                                        {getVehicleNumberValuesDWeb(tripDetails.vehicleNumber).map((vehicleNumber, index) => (
                                                            <>
                                                                <div className={classes.divAlignV1}>
                                                                    <div className={index != 0 ? classes.mlV1 : ""}>{vehicleNumber}</div>
                                                                </div>
                                                            </>
                                                        ))}
                                                    </>
                                                }
                                            </Grid>
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                        </>
                    }

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >

                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Close
                    </Button>

                </SideBarDialogActions>
            </Drawer>

            {/* {deletePayment && <DeleteTransactionDialog open={deletePayment} onClose={handleDeletePaymentClose} onConfirm={handleDeletePaymentConfirm} paymentId={transactionId} />} */}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetSinglePartyPayment: (partyId, transactionId, onSuccess, onError) => {
        dispatch(getSinglePartyPaymentDetails(partyId, transactionId, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetailsSideBar);